<l-page [tabHeaders]="['Resources']"
        [tabHeadersIcons]="['fas fa-play-circle']">
  <app-resources-frame tab0></app-resources-frame>
</l-page>
